export const MOTIVATOR_SURVEY_TYPE_ID = 4;
export const ENGAGEMENT_SURVEY_TYPE_ID = 5;
export const DIRECT_QUESTION_TYPE = 'uwes';
